import React from 'react'
import styled from 'styled-components'

import ArrowDown from "../../../images/icons/MenuArrowDown.svg"
import WhiteArrowDown from "../../../images/icons/MenuArrowDownWhite.svg"
import theme from "../../../styles/theme"

const Arrow = styled.img`
  width: 15px;
  margin-left: 3px;
  transition-duration: ${theme.transitionDuration};
  ${props => props.rotating ? `transform: rotate(180deg);` : `transform: none;`}
`

export default ({ rotating, ...props }) => <Arrow {...props} rotating={rotating} src={props.darkMode ? WhiteArrowDown : ArrowDown} />